import Button from 'components/Button';
import ModalCommon from 'components/Input/ModalCommon';
import { NO_INTERNET } from 'components/messageError';
import React, { useState } from 'react';
import CourseScheduleRegistationServices from 'services/CourseScheduleRegistationServices';
import { toast } from 'sonner';

const PopupConfirm = ({
  isOpen,
  onCancel,
  status,
  beforeStatus,
  courseId,
  onSuccess,
  message,
}) => {
  const [loading, setLoading] = useState(false);

  const changeStatusAction = () => {
    setLoading(true);
    CourseScheduleRegistationServices.changeStatus(courseId, {
      status: status,
      beforeStatus: beforeStatus,
    })
      .then(() => {
        onSuccess();
        onCancel();
      })
      .catch((err) => {
        toast.error(err || NO_INTERNET);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleConfirm = () => changeStatusAction();
  return (
    <ModalCommon
      title={'ステータス'}
      width={600}
      heightHeader={54}
      open={isOpen}
      onCancel={onCancel}
      footer={
        <div className="flex h-max justify-end gap-5 border-t border-[#e9e9e9] pt-[15px]">
          <Button btnType="back" width={120} height={40} onClick={onCancel}>
            キャンセル
          </Button>
          <Button
            type="primary"
            width={120}
            height={40}
            onClick={handleConfirm}
            fontSize={14}
            loading={loading}
          >
            <p style={{ letterSpacing: '0', fontSize: 14 }}>承認</p>
          </Button>
        </div>
      }
    >
      <div
        style={{
          textAlign: 'center',
          height: 130,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 20,
          fontSize: '15px',
          fontWeight: '400',
          color: '#000000',
          whiteSpace: 'pre-line',
        }}
      >
        {message}
      </div>
    </ModalCommon>
  );
};

export default PopupConfirm;
